export const GALLERY_IMAGE_SIZE = '168px';
export const GALLERY_MIN_TILE_SIZE = '136px';
export const GALLERY_GRID_GAP = '16px';
export const GALLERY_GRID_COLUMNS = 4;
export const GALLERY_CONTAINER_WIDTH = '1428px';
export const GALLERY_NATIVE_CONTAINER_WIDTH = 348;
/** Native's photo width, and the reading width of the text and controls under a photo on web. */
export const MAX_LIGHTBOX_IMAGE_WIDTH = 450;
export const MAX_LIGHTBOX_IMAGE_HEIGHT = 500;

/** The `large_uncropped` rendition's 1024px box: any wider and the photo upscales. */
export const MAX_LIGHTBOX_WEB_IMAGE_WIDTH = 1024;
/** Room each side for the prev/next arrows: their 16px inset, 40px button, and a 16px gap. */
export const LIGHTBOX_ARROW_GUTTER = 72;
/**
 * Vertical room for the overlay padding, the close bar, and the counter. The
 * lightbox measures what sits under the photo and reserves that on top.
 */
export const LIGHTBOX_RESERVED_HEIGHT = 136;
export const MIN_LIGHTBOX_IMAGE_HEIGHT = 240;

export const DIMMED_IMAGE_OPACITY = 0.5;

// Photo moderation rejects every other image type.
export const GALLERY_UPLOAD_ACCEPT = 'image/jpeg,image/png,image/heic,image/heif';

export const ROLLOUT_STAY_PHOTO_PRIVACY = 'rollout_stay_photo_privacy';

/**
 * Diameter of the play badge on a video tile, unitless so each platform can
 * format it as it needs.
 *
 * The glyph is drawn at this size too, but does not fill it: `play-glyph.svg`
 * insets its triangle within a 40x40 viewBox, so the visible triangle lands at
 * roughly 40% of the badge. Re-cropping that asset changes the badge's
 * appearance with no change here.
 */
export const PLAY_BADGE_SIZE = 50;

/**
 * Opacity of the badge's scrim. Load-bearing for the contrast between the white
 * glyph and whatever photo is behind it, so web and native have to agree.
 */
export const PLAY_BADGE_OPACITY = 0.48;

export const ACTIONS_TESTID = 'gallery-image-actions';
export const ACTIONS_SELECTOR = `[data-testid="${ACTIONS_TESTID}"]`;

// Unitless so each platform can format it.
export const PRIVATE_BADGE_SIZE = 26;
export const PRIVATE_BADGE_GLYPH_SIZE = 14;
export const SELECTION_CHECKBOX_SIZE = 24;

/**
 * The checkbox chrome, taken from Kibble's `CheckboxField` control so the tile
 * reads as the same checkbox the rest of the product uses.
 *
 * `check-small.svg` insets its glyph, so the view box crops that padding away
 * rather than the glyph being drawn small inside the box.
 */
export const SELECTION_CHECKBOX_BORDER_WIDTH = '2px';
export const SELECTION_CHECKBOX_GLYPH_SIZE = 12;
export const SELECTION_CHECKBOX_GLYPH_VIEW_BOX = '8 8 16 16';

/** Matches the endpoint's limit; it rejects a larger request rather than truncating it. */
export const MAX_IMAGE_VISIBILITY_BATCH_SIZE = 100;
